import { InitialState, TableFilter } from "./tableFilter";
import StringFilter from "../StringFilter";

class StringFilterModel extends TableFilter {
  constructor(initialState = undefined) {
    if (initialState === undefined)
      initialState = new InitialState([{ value: "" }]);
    super(StringFilter, initialState);
  }
}
export default StringFilterModel;
